import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { Control } from '../../_models/control';
import { ControlService } from '../../_services/control.service';
import { ListaService } from '../../_services/lista.service';
import { SelectItem } from 'primeng/api';
import { ListaItem } from '../../_models/lista-item';
import { CentralRiesgoIntegracionService } from '../../_services/central-riesgo-integracion.service';
import { CentralRiesgoIntegracion } from '../../_models/central-riesgo-integracion';

@Component( {
  selector: 'app-central-riesgo-integracion-listado',
  templateUrl: 'central-riesgo-integracion-listado.component.html'
} )

export class CentralRiesgoIntegracionListadoComponent implements OnInit {

  controles: Control[] = [];
  lisIntegracionesTodas: ListaItem[] = [];
  lisCentralRiesgoIntegracion: CentralRiesgoIntegracion[] = [];
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

  constructor( private conControlesServicio: ControlService,
               private navServicio: NavService,
               private router: Router,
               private lisServicio: ListaService,
               private autServicio: AutenticacionService,
               private serCentralRiesgoIntegracion: CentralRiesgoIntegracionService ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/central-riesgo-integracion' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'integracion', header: this.navServicio.buscarMensaje( 'CENTRALRIESGO.LBL_INTEGRACION' ), sort: true },
      { field: 'indicadorEncendido', header: this.navServicio.buscarMensaje( 'CENTRALRIESGO.LBL_ENCENDIDOANALIZAMOS' ), sort: true },
      { field: 'indicadorEncendidoAliado', header: this.navServicio.buscarMensaje( 'CENTRALRIESGO.LBL_ENCENDIDOALIADOS' ), sort: true },
      { field: 'indicadorEncendidoPersonas', header: this.navServicio.buscarMensaje( 'CENTRALRIESGO.LBL_ENCENDIDOPERSONAS' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'central-riesgo-integracion.component' );
    this.serCentralRiesgoIntegracion.listado().subscribe( cenRiesIntegracion => {
      this.lisCentralRiesgoIntegracion = cenRiesIntegracion;
      this.carTabla = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );
  }

  crear() {
    this.router.navigate( [ 'apl/central-riesgo-integracion/agregar' ] );
  }

  visualizar(cenRieInt: CentralRiesgoIntegracion) {
    this.router.navigate( [ 'apl/central-riesgo-integracion/detalle/' + cenRieInt.idCentralRiesgoIntegracion ] );
  }

  editar( cenRieInt: CentralRiesgoIntegracion ) {
    this.router.navigate( [ 'apl/central-riesgo-integracion/actualizar/' + cenRieInt.idCentralRiesgoIntegracion ] )
  }

  setBusqueda() {
    this.navServicio.setSearch( 'central-riesgo-integracion.component', this.busqueda );
  }
}
